import { useEffect, useState } from "react";
import { notification } from "antd";

const NetworkListener = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const offlineNotificationKey = "offline-alert";

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      notification.destroy();
      notification.success({
        message: " You are Online",
        duration: 1,
      });
    };

    const handleOffline = () => {
      setIsOnline(false);
      notification.error({
        key: offlineNotificationKey,
        message: " You are Offline",
        description: "Please check your internet connection.",
        duration: 0, 
      });
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    if (!navigator.onLine) handleOffline();

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return null;
};

export default NetworkListener;
